<script>
    import getSecret from '@utils/get-secret'
    import Layout from '@layouts/main'
    import PageHeader from '@components/page-header'
    import BaseDatatable from '@components/base-datatable'
    import { euroInventoryMethods, euroCouponsTutorialMethods } from '@state/helpers'
    import cardholderForm from '@views/timesoft/form'
    import cardholderDelete from '@components/euro_smart_car/delete'
    import InputValidation  from "@/src/components/form/InputValidation.vue";
    import CustomMultiselect from '@/src/components/CustomMultiselect.vue'
    import Multiselect from 'vue-multiselect'
    
    export default {
      page: {
        title: 'Homologacion Productos',
        meta: [{ name: 'description', content: getSecret('DESCRIPTION') }],
      },
      components: {
        UploadData: () => import('@components/euro_inventory/UploadData'),
        Layout, PageHeader, BaseDatatable, 
        cardholderForm, cardholderDelete,InputValidation,CustomMultiselect,Multiselect },
      data() {
        return {
          title: 'Homologacion Productos',
          is_homologated_filter: [
        { text: 'SI', value: "true" },
        { text: 'NO', value: "false" },
      ],
          filters: {
            sku: '',
            ean: '',
            name: '',
            supplier: '',
            nit_supplier: '',
            is_homologated: '',
          },
          items: [
            {
              text: 'Inicio',
              href: '/',
            },
            {
              text: 'Homologacion Productos',
              active: true,
            },
          ],
          tableHeaders: ['sku', 'ean','name','supplier','nit_supplier','sku_supplier','ean_supplier','name_supplier','is_homologated'],
          
          action: '',
          detailModal: {
            id: 'info-modal',
            title: '',
            content: '',
          },
          toUpdate : {},
          toDelete: {},
          showForm: false,
          showFormEdit: false,
          showFormDelete: false,
          typeAction:'create',
          showDelete: false,
          isSubmitting: false,
          actionsLoadings: {},
        }
      },
      computed: {
        products() {
          return this.$store.state.euroInventory.products;
        },
      },
      mounted() {
        this.setShowTutorial(true)
        this.setTutorialUrl('homologated')
        this.fetchProducts();
        
      },
      destroyed() {
        this.setShowTutorial(false)
      },
      
      methods: {
        ...euroInventoryMethods,
        ...euroCouponsTutorialMethods,
        myProvider(ctx) {
        let context = this;
        ctx = context.$table_params(ctx);
        const filters = Object.entries(context.filters)
        
          .filter(([key, value]) => value !== '')
          .map(([key, value]) => `${key}=${value}`)
          .join('&');
        ctx += filters ? `&${filters}` : '';

        const promise = context.fetchProducts(ctx);
        
        return promise
          .then((products) => {
            
            products.results.forEach((product) => {
              product.is_homologated = product.is_homologated ? 'SI' : 'NO';
            });
            return products;
          })
          .catch((error) => {
            this.$axios_error_noty(error, this);
            return [];
          });
      },
        clear() {
          this.filters.sku = '';
          this.filters.ean = '';
          this.filters.name = '';
          this.filters.supplier = '';
          this.filters.nit_supplier = '';
          this.filters.is_homologated = '';
          this.applyFilters(); 
        },
        filtersApplied() {
        return Object.values(this.filters).some(value => value !== '');
      },
      updateFilter(value) {
        console.log(value)
        if (value !== 'null') {
          this.filters.is_homologated = value;

        }
      },
        applyFilters() {
          const filtersCopy = { ...this.filters };


          const filtersQuery = Object.entries(filtersCopy)
            .map(([key, value]) => (value !== '' ? `${key}=${value}` : null))
            .filter(Boolean)
            .join('&');

          this.$refs.table.refresh(filtersQuery);
        },
        openCreateUpdateModal(filters) {

        this.toUpdate = {};
        this.showForm = true;
        this.typeAction = 'create';
        this.$refs.uploadData.setFilters(filters);
      },
      setFilters(filters) {
        this.filters = { ...filters };
      },
      labelOfOption(opt, options) {
        let optionFound = options.find((x) => x.value === opt);
        let optionsCache = [];
        if (!optionFound) {
          let cacheFound = optionsCache.find((x) => x.value === opt);
          return cacheFound ? cacheFound.text : false ? `${opt}` : "";
        } else {
          return optionFound.text;
        }
      },
      },
    };
    </script>


<template>
  <Layout>
    <!-- Page Header -->
    <PageHeader :title="title" :items="items" />

    <!-- Main Content Container -->
    <b-container fluid class="ml-2">

      <!-- Upload Data Button -->
      <b-card class="shadow-sm">

          <!-- Upload Data Component -->
          <div class="mt-3">
            
            <UploadData
              v-if="showForm"
              ref="uploadData" 
              :type_action="typeAction"
              :fullform="true"
              :instanceJson="toUpdate || {}"
              :filters="filters"
              :oncomplete="() => { toUpdate = {}; showForm = false; $refs.table.refresh(); }"
              :oncancel="() => { toUpdate = {}; showForm = false; }"
            ></UploadData>
            <div class="float-right mt-0 ml-auto mt-0 " >
            <b-row>
              <b-col  md="3" class="ml-auto pt-3 pr-1 mt-1" >
                <b-button
                  class="rounded shadow-sm float-right"
                  variant="outline-primary"
                  @click="applyFilters"
                >
                  <i class="fas fa-filter"></i> 
                </b-button>
              </b-col>
              <b-col md="1" class="ml-auto pt-3 pr-1 mt-1">            
                <b-button
                  class="rounded shadow-sm float-right"
                  variant="outline-primary rounded-lg shadow-sm"
                  @click="openCreateUpdateModal(filters)"
                >
                  <i class="fas fa-plus"></i>
                </b-button>
              </b-col>
              <b-col md="1" class="ml-auto pt-3 pr-1 mt-1">
                  <b-button
                    class="rounded shadow-sm float-right"
                    variant="outline-primary"
                    @click="clear"
                  >
                    <i class="fas fa-eraser"></i>
                  </b-button>
                </b-col>
            </b-row>
            
          </div>
          </div>
        
          <b-row class="px-2 " >
            
            <b-row class="text-primary px-2 mb-2" style="font-size: 16px">
                <b>{{  $t("filters") }}</b>
          </b-row>

        </b-row>
 
        

        <b-row>
          <!-- Filter Input Fields -->
          <b-col md="3" class="ml-2" style="margin: 0 1rem 0 0">
            <InputValidation
            
              vid="sku-validation"
              :rules="{ required: false, min: 1, max: 50 }"
              v-model="filters.sku"
              placeholder="Filtrar por SKU"
              :state="null"
            />
            
          </b-col>

          <b-col md="3" class="ml-2" style="margin: 0 1rem 0 1rem">
            <InputValidation
              vid="ean-validation"
              :rules="{ required: false, min: 1, max: 50 }"
              v-model="filters.ean"
              placeholder="Filtrar por EAN"
              :state="null"
            />
          </b-col>

          <b-col md="3" class="ml-2" style="margin: 0 1rem 0 1rem">
            <InputValidation
              vid="name-validation"
              :rules="{ required: false, min: 1, max: 50 }"
              v-model="filters.name"
              placeholder="Filtrar por Nombre"
              :state="null"
            />
          </b-col>

          <b-col md="3" class="ml-2" style="margin: 0 1rem 0 1rem">
            <InputValidation
              vid="supplier-validation"
              :rules="{ required: false, min: 1, max: 50 }"
              v-model="filters.supplier"
              placeholder="Filtrar por Proveedor"
              :state="null"
            />
          </b-col>

          <b-col md="3" class="ml-2" style="margin: 0 1rem 0 1rem">
            <InputValidation
              vid="nit-supplier-validation"
              :rules="{ required: true, min: 3, max: 30 }"
              v-model="filters.nit_supplier"
              placeholder="Filtrar por NIT Proveedor"
              
            />
          </b-col>

          <b-col md="3" class="ml-2" style="margin: 0 1rem 0 1rem">
            <multiselect

              v-model="filters.is_homologated"
              :options="is_homologated_filter.map((line) => line.value)"
              :custom-label="(opt) => labelOfOption(opt, is_homologated_filter)" 
              :placeholder="'Homologado'"
              @input="updateFilter"
              label="label"
              :select-label="'Presiona Enter para seleccionar'"
              :deselect-label="$t('press_enter_to_remove')"
            ></multiselect>
          </b-col>

        </b-row>
      </b-card>

      <!-- Data Table Section -->
      <b-row>
        <b-col>
          <b-card class="shadow">
            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders.map(header => ({ key: header, label: $t(`tableHeaders.${header}`) }))"
              :filterOption="false"
            ></BaseDatatable>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </Layout>
</template>